import React from "react";

export default function Layout({ children, heading, handleBackBtn }) {
  return <>
   <button
      onClick={() => handleBackBtn()}
      >
        <img src="/back-arrow.svg" alt="back-arrow-icon" />
      </button>
      <h2 className="mb-8 text-2xl font-bold text-black dark:text-white sm:text-title-xl2 text-center">
        {heading}
      </h2>
  {children}</>;
}
